import React from "react";
import "./avcsExplainedModal.scss";
import { Icons } from "../../atoms/Icons";
const AVCsExplainedModal = (props) => {
  return (
    <div className="avcs-explained-modal">
      <div className="text-end">
        <Icons
          iconname="close-large"
          variant="icon-sixteen-px"
          clickHandler={props.handleCloseButton}
        />
      </div>
      <div className="heading mt-2 mb-4">{props.headTitle}</div>
      <div className="sub-text">
        <p>{props.description}</p>
        <p>{props.subDescription}</p>
        <p>{props.subDescription1}</p>
      </div>
    </div>
  );
};

export default AVCsExplainedModal;
